import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import Address from "../../Common/Address";
import PersonIcon from "@mui/icons-material/Person";
import {
    getVendorDetails,
    updateVendorDetailsByUUID,
    addVendor,
    getTdsKeyValuePair,
    getPaymentTermKeyValuePair,
    getPurchasePriceKeyValuePair,
    getWarehouseKeyValueList,
} from "../../../services/index";
import { Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { VENDOR_CATEGORY_URL } from "../../../CONSTANTS";
import { callGetAxios } from "../../../services/common/common";

const VendorNew = (props) => {
    let { id } = useParams();
    let navigate = useNavigate();

    const [ware, setWare] = useState("");
    const [wareOptions, setWareOptions] = useState("");
    const [tdsOptions, setTdsOptions] = useState([]);
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [vendorCatOptions, setVendorCatOptions] = useState([]);
    const [payTermOptions, setPayTermOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const [vendorInfo, setVendorInfo] = useState({
        name: "",
        email: "",
        phone: "",
        gst: "",
        fssai: 1,
        tds: "",
        priceList: "",
        vendorCategory: "",
        payTerm: "",
        remark: "",
    });

    const [child1, setChild1] = useState({
        addressType: "Billing",
        country: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pinCode: "",
    });

    const [child2, setChild2] = useState({
        addressType: "Shipping",
        country: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        pinCode: "",
    });

    const handleCopy = (d) => {
        d.addressType = "Shipping";
        setChild2(d);
    };

    const handleData = (e, key) => {
        if (e.value && e.label) {
            setVendorInfo({
                ...vendorInfo,
                [key]: e,
            });
        } else if (e.target.value) {
            setVendorInfo({
                ...vendorInfo,
                [e.target.name]: e.target.value,
            });
        } else {
            setVendorInfo({
                ...vendorInfo,
                [e.target.name]: "",
            });
        }
    };

    const handleChild1 = (e, key) => {
        if (e.value && e.label) {
            setChild1({
                ...child1,
                [key]: e,
            });
        } else if (e.target.value) {
            setChild1({
                ...child1,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleChild2 = (e, key) => {
        if (e.value && e.label) {
            setChild2({
                ...child2,
                [key]: e,
            });
        } else if (e.target.value) {
            setChild2({
                ...child2,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleGetVendorDetails = () => {
        getVendorDetails(id)
            .then((res) => {
                if (res.errorCode === 0) {
                    const dd = res.responsePacket;
                    let d = res.responsePacket.addressList;

                    let child1 = d.filter((a) => a.addressType === "Billing");
                    child1.map((a) => {
                        a.country = { value: "c", label: a.country };
                        a.state = { value: "b", label: a.state };
                    });

                    let child2 = d.filter((a) => a.addressType === "Shipping");
                    child2.map((a) => {
                        a.country = { value: "c", label: a.country };
                        a.state = { value: "b", label: a.state };
                    });

                    let a1 = child1[0];
                    let a2 = child2[0];
                    if (a1 !== undefined) {
                        setChild1(a1);
                    }
                    if (a2 !== undefined) {
                        setChild2(a2);
                    }

                    setVendorInfo({
                        name: dd.title,
                        email: dd.email,
                        phone: dd.phone,

                        gst: dd.gstNumber,
                        tds: {
                            value: dd.tdsRecordId,
                            label: dd.tdsTitle,
                        },
                        priceList: {
                            value: dd.itemPriceListRecordId,
                            label: dd.itemPriceListTitle,
                        },
                        vendorCategory: {
                            value: dd.vendorCategoryId,
                            label: dd.vendorCategory,
                        },
                        payTerm: {
                            value: dd.paymentTermRecordId,
                            label: dd.paymentTermTitle,
                        },
                        remark: dd.remark,
                    });

                    if (dd.warehouseVendorBeanList) {
                        dd.warehouseVendorBeanList.map((a) => {
                            a.value = a.warehouseId;
                            a.label = a.warehouseTitle;
                            setWare({ value: a.warehouseId, label: a.warehouseTitle });
                        });
                    }
                } else {
                    toast(res.message);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    useEffect(() => {
        if (id) {
            handleGetVendorDetails();
        }
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                const d = res.responsePacket;
                const options = d.map((a) => ({
                    label: a.value,
                    value: a.key,
                }));
                setWareOptions(options);
                options.map((a) => {
                    if (a.label === "Mohra") {
                        setWare(a);
                    }
                });
            } else {
                toast(res.message);
            }
        });

        getPurchasePriceKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setPriceListOptions(options);
            } else {
                toast(res.message);
            }
        });

        const getVendorsCategoryKeyValuePairs = async () => {
            try {
                const rUrl = VENDOR_CATEGORY_URL() + "getKeyValueList"
                const res = await callGetAxios(rUrl)
                if (res.errorCode === 0) {
                    const options = res.responsePacket.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setVendorCatOptions(options);
                } 
            } catch (error) {
                console.error(error)
            }
        }
        getVendorsCategoryKeyValuePairs()

        getPaymentTermKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setPayTermOptions(options);
            } else {
                toast(res.message);
            }
        });
        getTdsList();
    }, []);

    const getTdsList = () => {
        getTdsKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));

                setTdsOptions(options);
            } else {
                toast(res.message);
            }
        });
    };

    const handleSaveVendor = () => {
        let ar = [];

        var deepCopy1 = JSON.parse(JSON.stringify(child1));
        var deepCopy2 = JSON.parse(JSON.stringify(child2));

        deepCopy1.state = child1?.state?.label;
        deepCopy1.country = child1?.country?.label;

        deepCopy2.state = child2?.state?.label;
        deepCopy2.country = child2?.country?.label;

        ar.push(deepCopy1);
        ar.push(deepCopy2);

        if (!child1.country.label || !child2.country.label) {
            toast("Please select both country");
            return;
        }
        if (!child1.state.label || !child2.state.label) {
            toast("Please select both state");
            return;
        }
        if (!child1.city || !child2.city) {
            toast("Please select both city");
            return;
        }
        if (!child1.pinCode || !child2.pinCode) {
            toast("Please select both pinCode");
            return;
        }
        if (!child1.addressLine1 || !child2.addressLine1) {
            toast("Please select both addressLine1");
            return;
        }
        if (!child1.addressLine2 || !child2.addressLine2) {
            toast("Please select both addressLine2");
            return;
        }

        if (!vendorInfo.name) {
            toast("Please select Company's Name");
            return;
        }

        if (!vendorInfo.phone || (vendorInfo?.phone).toString().length !== 10) {
            toast("Please enter 10 Digit phone");
            return;
        }

        if (!vendorInfo.gst || vendorInfo?.gst.toString().length !== 15) {
            toast("Please enter 15 digit GST no.");
            return;
        }
        if (!vendorInfo.vendorCategory) {
            toast("Please select vendor category");
            return;
        }

        // for (let x in child1) {
        //   if (child1[x] === "" || child1[x] === undefined) {
        //     toast(`Empty field Billing: ${[x]} `, {
        //       autoClose: 4000,
        //       closeOnClick: true,
        //       pauseOnHover: true,
        //     });
        //     doNotSave = true;
        //     return;
        //   }
        // }

        setLoading(true);

        var request = {
            vendorFssai: vendorInfo?.fssai,
            salutation: "Mr",
            currencyRecordId: "dad7fa51-f498-42fb-a2d9-8efe52269ffc",
            currencyRecordTitle: "INR - Indian Rupee",
            warehouseVendorBeanList: [{ warehouseTitle: ware.label, warehouseId: ware.value }],
            addressList: ar,
            companyTitle: vendorInfo?.name?.trim(),
            fullName: vendorInfo.name?.trim(),
            title: vendorInfo.name?.trim(),
            email: vendorInfo.email?.trim(),
            gstNumber: vendorInfo.gst,
            itemPriceListTitle: vendorInfo.priceList.label,
            itemPriceListRecordId: vendorInfo.priceList.value,
            priceList: vendorInfo.priceList.value,
            vendorCategoryId: vendorInfo.vendorCategory.value,
            vendorCategory: vendorInfo.vendorCategory.label,
            paymentTermRecordId: vendorInfo.payTerm.value,
            paymentTermTitle: vendorInfo.payTerm.label,
            phone: vendorInfo.phone,
            tdsRecordId: vendorInfo.tds.value,
            tdsTitle: vendorInfo.tds.label,
            remark: vendorInfo.remark,
        };
        if (id) {
            updateVendorDetailsByUUID(id, request).then((res) => {
                if (res.errorCode === 0) {
                    toast(res.message);
                    navigate("/vendors");
                    setLoading(false);
                } else {
                    toast(res.message);
                    setLoading(false);
                }
            });
        } else {
            addVendor(request).then((res) => {
                if (res.errorCode === 0) {
                    toast(res.message);
                    navigate("/vendors");
                    setLoading(false);
                } else {
                    toast(res.message);
                    setLoading(false);
                }
            });
        }
    };

    return (
        <>
            <div className="containBox">
                <div className="row1" style={{ fontSize: "16px", height: "30px" }}>
                    <PersonIcon />
                    &nbsp; New Vendor
                </div>
                <br />
                <div>
                    <table className="requiredTable">
                        <tr>
                            <td style={{ width: "150px" }}>Company's Name</td>
                            <td style={{ width: "250px" }}>
                                <input
                                    autoComplete="off"
                                    name="name"
                                    className="form-control "
                                    value={vendorInfo.name}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Email</td>
                            <td>
                                {" "}
                                <input
                                    autoComplete="off"
                                    name="email"
                                    className="form-control "
                                    value={vendorInfo.email}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Phone</td>
                            <td className="otp-spin">
                                {" "}
                                <input
                                    autoComplete="off"
                                    name="phone"
                                    type="number"
                                    className="form-control "
                                    value={vendorInfo.phone}
                                    onChange={(e) => {
                                        const limitedValue = e.target.value.slice(0, 10);
                                        setVendorInfo({ ...vendorInfo, phone: limitedValue });
                                      }}
                                    // onChange={(e) => {
                                    //     handleData(e);
                                    // }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Warehouse</td>
                            <td>
                                {" "}
                                <Select options={wareOptions} value={ware} onChange={(e) => setWare(e)} />
                            </td>
                        </tr>
                        <tr>
                            <td>GST</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    name="gst"
                                    className="form-control "
                                    value={vendorInfo.gst}
                                    onChange={(e) => {
                                        const limitedValue = e.target.value.slice(0, 15);
                                        setVendorInfo({ ...vendorInfo, gst: limitedValue });
                                      }}
                                    // onChange={(e) => {
                                    //     handleData(e);
                                    // }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>FSSAI</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    name="fssai"
                                    type="number"
                                    className="form-control "
                                    value={vendorInfo.fssai}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "black" }}>TDS</td>
                            <td>
                                <Select
                                    name="tds"
                                    options={tdsOptions}
                                    value={vendorInfo.tds}
                                    onChange={(e) => {
                                        handleData(e, "tds");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>PriceList</td>
                            <td>
                                <Select
                                    name="priceList"
                                    options={priceListOptions}
                                    value={vendorInfo.priceList}
                                    onChange={(e) => {
                                        handleData(e, "priceList");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Vendor Category</td>
                            <td>
                                <Select
                                    name="priceList"
                                    options={vendorCatOptions}
                                    value={vendorInfo.vendorCategory}
                                    onChange={(e) => {
                                        handleData(e, "vendorCategory");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td>Payment Terms</td>
                            <td>
                                <Select
                                    name="payTerm"
                                    options={payTermOptions}
                                    value={vendorInfo.payTerm}
                                    onChange={(e) => {
                                        handleData(e, "payTerm");
                                    }}
                                />
                            </td>
                        </tr>
                        <tr style={{ color: "black" }}>
                            <td>Remark</td>
                            <td>
                                <input
                                    autoComplete="off"
                                    name="remark"
                                    className="form-control "
                                    value={vendorInfo.remark}
                                    onChange={(e) => {
                                        handleData(e);
                                    }}
                                />
                            </td>
                        </tr>
                    </table>

                    <Address handleChild1={handleChild1} child1={child1} handleChild2={handleChild2} child2={child2} handleCopy={handleCopy} />
                    <div>
                        {loading ? (
                            <Button variant="contained">
                                <Spinner />
                            </Button>
                        ) : (
                            <Button variant="contained" onClick={handleSaveVendor}>
                                Save
                            </Button>
                        )}
                    </div>
                </div>
            </div>

            <Toaster />
        </>
    );
};

export default VendorNew;
